module.exports = __webpack_public_path__ + "img/css.2259dde6.svg";